import { combineReducers } from "@reduxjs/toolkit";

import {
	settingsFinancesCustomerTariffPlansDataModalState,
	settingsFinancesCustomerTariffPlansDataModalReducer,
	settingsFinancesCustomerTariffPlansDataModalAction,
} from "./dataModal";

export type StateCustomerTariffPlans = {
	dataModal: settingsFinancesCustomerTariffPlansDataModalState;
};

export const customerTariffPlans = combineReducers<StateCustomerTariffPlans>({
	dataModal: settingsFinancesCustomerTariffPlansDataModalReducer,
});

export const settingsFinancesCustomerTariffPlansAction = {
	dataModal: settingsFinancesCustomerTariffPlansDataModalAction,
};

export default customerTariffPlans;
